'use strict';

import formValidation from '../components/formValidation';

var uploadedFiles = [];

function validateRequiredFields() {
    var allFilled = true;
    var $form = $('#contact-form');

    $form.find('input.js-form-control, textarea.js-form-control, select.js-form-control').each(function () {
        var $field = $(this);
        var $formGroup = $field.closest('.cc-form__group');

        if ($field.attr('type') === 'file') {
            return true;
        }

        if ($formGroup.hasClass('required') && !$field.prop('disabled') && $formGroup.is(':visible')) {
            var value = $field.val();

            if (!value || (typeof value === 'string' && value.trim() === '') || (Array.isArray(value) && value.length === 0)) {
                allFilled = false;
                return false;
            }
        }
    });

    var $submitBtn = $('.js-submitContactForm');
    $submitBtn.prop('disabled', !allFilled);
    $submitBtn.toggleClass('cc-disabled', !allFilled);
}

$(() => {
    var $form = $('#contact-form');
    $form.find('.js-form-control:disabled[required]').each(function () {
        var $field = $(this);
        var $formGroup = $field.closest('.cc-form__group');
        var value = $field.val();

        if ($formGroup.hasClass('required') && (!value || (typeof value === 'string' && value.trim() === ''))) {
            $field.prop('disabled', false);
        }
    });

    var $caseTypeSelect = $('#contact-form-caseType');
    var $caseSubTypeSelect = $('#contact-form-caseSubType');

    $('.js-submitContactForm').prop('disabled', true).addClass('cc-disabled');

    $('#contact-form').on('input change', '.js-form-control', function () {
        $('.js-errorContact').addClass('d-none');
        validateRequiredFields();
    });

    $('#contact-form').on('changed.bs.select', '.js-sp', function () {
        $('.js-errorContact').addClass('d-none');
        validateRequiredFields();
    });

    validateRequiredFields();

    $caseTypeSelect.on('change', function () {
        var selectedType = $(this).val();
        $caseSubTypeSelect.val('');

        var $allSubOptions = $caseSubTypeSelect.find('option.js-subType');
        $allSubOptions.prop('disabled', true).hide();

        if (selectedType) {
            var $matches = $caseSubTypeSelect.find('option.js-subType[data-parent-type="' + selectedType + '"]');

            if ($matches.length > 0) {
                $matches.prop('disabled', false).show();
                $caseSubTypeSelect.prop('disabled', false);
            } else {
                $caseSubTypeSelect.prop('disabled', true);
            }
        } else {
            $caseSubTypeSelect.prop('disabled', true);
        }

        $caseSubTypeSelect.selectpicker('refresh');

        // Show order number field only for "orders" category
        var $orderNoGroup = $('.js-orderNoGroup');
        if (selectedType === 'orders') {
            $orderNoGroup.removeClass('d-none');
        } else {
            $orderNoGroup.addClass('d-none');
            $orderNoGroup.find('input').val('');
        }

        validateRequiredFields();
    });
});

const headerHeight = $('.cc-header').height() || 0;

function scrollToElement($message) {
    const scrollAnimateOffset = $message.offset().top - headerHeight - 100;
    $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);
}

function handleResponse($response, errorMessage) {
    const $errorContact = $('.js-errorContact');
    const $errorText = $('.js-errorText');
    const $contactForm = $('.js-contactForm');
    const $successContact = $('.js-successContact');

    if ($('body').hasClass('modal-open')) {
        $('body').find('.cc-modal.show').modal('hide');
    }

    if ($response === 'success') {
        $contactForm.addClass('d-none');
        $successContact.removeClass('d-none');
        scrollToElement($successContact);
        uploadedFiles = [];
    } else {
        if (errorMessage) {
            $errorText.text(errorMessage);
        }
        $errorContact.removeClass('d-none');
        scrollToElement($errorContact);
    }

    $.spinner().stop();
}

$(document).on('click', '.js-submitContactForm', function (e) {
    var $form = $(this).closest('form');
    e.preventDefault();

    var maxSize = parseInt($('#contact-form-file').data('max-size')) || 5242880;
    var maxTotalSize = parseInt($('#contact-form-file').data('max-total-size')) || 5242880;
    var maxSizeMB = (maxSize / 1048576).toFixed(0);
    var maxTotalSizeMB = (maxTotalSize / 1048576).toFixed(0);

    // Calculate total size of all uploaded files
    var totalSize = 0;
    uploadedFiles.forEach(function (item) {
        if (item && !item.isError && item.file) {
            totalSize += item.file.size;
        }
    });
    var currentTotalSizeMB = (totalSize / 1048576).toFixed(2);

    var hasFileErrors = uploadedFiles.some(function (item) {
        return item && item.isError;
    });

    if (hasFileErrors) {
        var fileErrorMsg = $('#contact-form-file').data('error-file');
        fileErrorMsg = fileErrorMsg.replace('{0}', maxSizeMB).replace('{1}', currentTotalSizeMB);
        handleResponse('error', fileErrorMsg);
        return;
    }

    if (totalSize > maxTotalSize) {
        var fileErrorMsg = $('#contact-form-file').data('error-file');
        fileErrorMsg = fileErrorMsg.replace('{0}', maxSizeMB).replace('{1}', currentTotalSizeMB);
        handleResponse('error', fileErrorMsg);
        return;
    }

    var url = $form.attr('action');
    $('.js-submitContactForm').prop('disabled', true).addClass('cc-disabled');
    $.spinner().start();

    var formData = new FormData($form[0]);

    $.ajax({
        url: url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            if (!data.success) {
                formValidation($form, data);
                validateRequiredFields();
            } else {
                handleResponse('success');
            }
            $.spinner().stop();
        },
        error: function () {
            var errorMsg = $('#contact-form-file').data('error-generic');
            $('.js-errorTitle').removeClass('d-none');
            handleResponse('error', errorMsg);
            $.spinner().stop();
        }
    });
});

// Validate file
function validateFile(file, maxSize, acceptedTypes) {
    var errors = [];

    if (file.size > maxSize) {
        errors.push({ type: 'size', message: $('#contact-form-file').data('error-size') });
    }

    var fileType = file.type;
    var fileName = file.name.toLowerCase();
    var isValidType = false;

    if ((acceptedTypes.includes('.jpg') || acceptedTypes.includes('.jpeg') || acceptedTypes.includes('image/jpeg')) &&
        (fileType === 'image/jpeg' || fileType === 'image/jpg' || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg'))) {
        isValidType = true;
    }
    else if ((acceptedTypes.includes('.png') || acceptedTypes.includes('image/png')) &&
        (fileType === 'image/png' || fileName.endsWith('.png'))) {
        isValidType = true;
    }
    else if ((acceptedTypes.includes('.pdf') || acceptedTypes.includes('application/pdf')) &&
        (fileType === 'application/pdf' || fileName.endsWith('.pdf'))) {
        isValidType = true;
    }
    else if ((acceptedTypes.includes('.doc') || acceptedTypes.includes('application/msword')) &&
        (fileType === 'application/msword' || fileName.endsWith('.doc'))) {
        isValidType = true;
    }
    else if ((acceptedTypes.includes('.docx') || acceptedTypes.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) &&
        (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || fileName.endsWith('.docx'))) {
        isValidType = true;
    }

    if (!isValidType) {
        errors.push({ type: 'type', message: $('#contact-form-file').data('error-type') });
    }

    return errors;
}

$(document).on('change', '#contact-form-file', function (e) {
    var files = e.target.files;
    var $filesList = $('.js-upload-filesList');
    var $fileInput = $(this);
    var maxSize = parseInt($fileInput.data('max-size')) || 5242880;
    var acceptedTypes = ($fileInput.attr('accept') || '.pdf,.jpg,.jpeg,.png,.doc,.docx').split(',');

    $('.js-errorContact').addClass('d-none');

    if (files && files.length > 0) {
        Array.from(files).forEach(function (file) {
            var fileIndex = uploadedFiles.length;
            var errors = validateFile(file, maxSize, acceptedTypes);
            var hasErrors = errors.length > 0;
            var errorMsg = hasErrors ? errors.map(function (e) { return e.message; }).join(', ') : '';

            if (hasErrors) {
                uploadedFiles.push({ file: null, isError: true, element: null, errorMsg: errorMsg });
            } else {
                uploadedFiles.push({ file: file, isError: false, element: null });
            }

            (function (currentFile, currentIndex, isError, errMsg) {
                var $progressWrapper = $('.js-template-progress-wrapper').clone();
                $progressWrapper.removeClass('js-template-progress-wrapper d-none');
                $progressWrapper.find('.js-template-progress').removeClass('js-template-progress');
                $progressWrapper.attr('data-file-index', currentIndex);
                $progressWrapper.find('.js-file-name').text(currentFile.name);
                $progressWrapper.find('.js-remove-single-file').attr('data-file-index', currentIndex);
                $filesList.append($progressWrapper);

                uploadedFiles[currentIndex].element = $progressWrapper;

                var progress = 0;
                var $progressFill = $progressWrapper.find('.cc-contact__upload__progress-fill');

                $progressFill.css('background', 'var(--color-primary)');

                var progressInterval = setInterval(function () {
                    progress += 10;
                    $progressFill.css('width', progress + '%');

                    if (progress >= 100) {
                        clearInterval(progressInterval);

                        if (isError) {
                            $progressFill.css('background', 'var(--color-error)');
                        } else {
                            $progressFill.css('background', 'var(--color-success)');
                        }

                        setTimeout(function () {
                            if (isError) {
                                var $errorTemplate = $('.js-template-error .cc-contact__upload__success-wrp').clone();
                                $errorTemplate.find('.js-error-message').text(errMsg);
                                $progressWrapper.find('.js-success-message-container').append($errorTemplate);
                            } else {
                                var $successTemplate = $('.js-template-success .cc-contact__upload__success-wrp').clone();
                                $progressWrapper.find('.js-success-message-container').append($successTemplate);
                            }
                        }, 300);
                    }
                }, 100);
            })(file, fileIndex, hasErrors, errorMsg);
        });

        var dt = new DataTransfer();
        uploadedFiles.forEach(function (item) {
            if (!item.isError && item.file) {
                dt.items.add(item.file);
            }
        });
        $fileInput[0].files = dt.files;

        if ($filesList.children().length > 0) {
            $filesList.removeClass('d-none');
        }
    }
});

$(document).on('click', '.js-remove-single-file', function (e) {
    e.preventDefault();
    var $button = $(this);
    var $fileInput = $('#contact-form-file');
    var fileIndex = parseInt($button.attr('data-file-index'));
    var $filesList = $('.js-upload-filesList');

    $('.js-errorContact').addClass('d-none');

    if (uploadedFiles[fileIndex]) {
        uploadedFiles[fileIndex] = null;
    }

    $filesList.find('[data-file-index="' + fileIndex + '"]').not($button).remove();

    var dt = new DataTransfer();
    uploadedFiles.forEach(function (item) {
        if (item && !item.isError && item.file) {
            dt.items.add(item.file);
        }
    });
    $fileInput[0].files = dt.files;

    if ($filesList.children().length === 0) {
        $filesList.addClass('d-none');
        uploadedFiles = [];
    }
});

var $uploadWrapper = $('.cc-contact__upload__wrp');

$(document).on('drag dragstart dragend dragover dragenter dragleave drop', '.cc-contact__upload__wrp', function (e) {
    e.preventDefault();
    e.stopPropagation();
});

$(document).on('dragover dragenter', '.cc-contact__upload__wrp', function () {
    $(this).addClass('cc-contact__upload__wrp--dragging');
});

$(document).on('dragleave dragend drop', '.cc-contact__upload__wrp', function () {
    $(this).removeClass('cc-contact__upload__wrp--dragging');
});

$(document).on('drop', '.cc-contact__upload__wrp', function (e) {
    var droppedFiles = e.originalEvent.dataTransfer.files;

    if (droppedFiles.length > 0) {
        var $fileInput = $('#contact-form-file');
        $fileInput[0].files = droppedFiles;
        $fileInput.trigger('change');
    }
});